import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Device } from '../device.model';

export enum DeviceActionTypes {
  GetDevices = '[Device] Get Devices',
  GetDevicesByAcodeList = '[Device] Get Devices By Acode List',
  LoadDevices = '[Device] Load Devices',
  AddDevice = '[Device] Add Device',
  UpsertDevice = '[Device] Upsert Device',
  AddDevices = '[Device] Add Devices',
  UpsertDevices = '[Device] Upsert Devices',
  UpdateDevice = '[Device] Update Device',
  UpdateDevices = '[Device] Update Devices',
  DeleteDevice = '[Device] Delete Device',
  DeleteDevices = '[Device] Delete Devices',
  ClearDevices = '[Device] Clear Devices',
  GetDevicesFail = '[Device] Get Devices Fail',
  NoDevicesChanged = '[Device] No Devices Changed'
}

export class GetDevices {
  readonly type = DeviceActionTypes.GetDevices;

  constructor(public payload: any[]) {}
}

export class GetDevicesByAcodeList {
  readonly type = DeviceActionTypes.GetDevicesByAcodeList;

  constructor(public payload: number[]) {}
}

export class GetDevicesFail {
  readonly type = DeviceActionTypes.GetDevicesFail;
}

export class LoadDevices implements Action {
  readonly type = DeviceActionTypes.LoadDevices;

  constructor(public payload: { devices: Device[] }) {}
}

export class AddDevice implements Action {
  readonly type = DeviceActionTypes.AddDevice;

  constructor(public payload: { device: Device }) {}
}

export class UpsertDevice implements Action {
  readonly type = DeviceActionTypes.UpsertDevice;

  constructor(public payload: { device: Device }) {}
}

export class AddDevices implements Action {
  readonly type = DeviceActionTypes.AddDevices;

  constructor(public payload: { devices: Device[] }) {}
}

export class UpsertDevices implements Action {
  readonly type = DeviceActionTypes.UpsertDevices;

  constructor(public payload: { devices: Device[] }) {}
}

export class UpdateDevice implements Action {
  readonly type = DeviceActionTypes.UpdateDevice;

  constructor(public payload: { device: Update<Device> }) {}
}

export class UpdateDevices implements Action {
  readonly type = DeviceActionTypes.UpdateDevices;

  constructor(public payload: { devices: Update<Device>[] }) {}
}

export class DeleteDevice implements Action {
  readonly type = DeviceActionTypes.DeleteDevice;

  constructor(public payload: { id: string }) {}
}

export class DeleteDevices implements Action {
  readonly type = DeviceActionTypes.DeleteDevices;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDevices implements Action {
  readonly type = DeviceActionTypes.ClearDevices;
}

export class NoDevicesChanged implements Action {
  readonly type = DeviceActionTypes.NoDevicesChanged;
}

export type DeviceActions =
 GetDevices
 | GetDevicesByAcodeList
 | LoadDevices
 | AddDevice
 | UpsertDevice
 | AddDevices
 | UpsertDevices
 | UpdateDevice
 | UpdateDevices
 | DeleteDevice
 | DeleteDevices
 | ClearDevices
 | GetDevicesFail
 | NoDevicesChanged;
